import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Typography, Paper, CircularProgress } from '@mui/material';
import FormInstituicao from '../../components/Instituicoes/FormInstituicao';
import { criarInstituicao, obterInstituicao, atualizarInstituicao } from '../../services/instituicaoService';

const CriarEditarInstituicaoPage = () => {
  const [instituicao, setInstituicao] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { id } = useParams();
  const navigate = useNavigate();
  const isEditMode = !!id;

  useEffect(() => {
    const fetchInstituicao = async () => {
      if (isEditMode) {
        try {
          setLoading(true);
          const data = await obterInstituicao(id);
          setInstituicao(data);
        } catch (error) {
          console.error('Erro ao buscar instituição:', error);
          setError('Não foi possível carregar os dados da instituição. Por favor, tente novamente.');
        } finally {
          setLoading(false);
        }
      } else {
        setLoading(false);
      }
    };

    fetchInstituicao();
  }, [id, isEditMode]);

  const handleSubmit = async (formData) => {
    try {
      setLoading(true);
      if (isEditMode) {
        await atualizarInstituicao(id, formData);
      } else {
        await criarInstituicao(formData);
      }
      navigate('/instituicoes');
    } catch (error) {
      console.error('Erro ao salvar instituição:', error);
      setError('Ocorreu um erro ao salvar a instituição. Por favor, tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <Paper sx={{ p: 2, display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '200px' }}>
        <CircularProgress />
      </Paper>
    );
  }

  if (error) {
    return (
      <Paper sx={{ p: 2 }}>
        <Typography color="error">{error}</Typography>
      </Paper>
    );
  }

  return (
    <Paper sx={{ p: 2 }}>
      <Typography variant="h4" gutterBottom>
        {isEditMode ? 'Editar Instituição' : 'Criar Nova Instituição'}
      </Typography>
      <FormInstituicao 
        onSubmit={handleSubmit} 
        instituicaoInicial={instituicao || {}}
      />
    </Paper>
  );
};

export default CriarEditarInstituicaoPage;